import React from 'react';
import withView from '../../../cmn/docAutomation/withView';
import SarasTrans from '../../../../library/notifications/SarasTrans';
import FormTitle from '../../../../library/form/components/FormTitle';
// import SarasDnDProvider from '../../../../library/hooks/bdnd/SarasDnDProvider';
// import { SarasDnDTypes } from '../../../../library/hooks/bdnd/SarasDnDTypes';
// import useSarasDnDManager from '../../../../library/hooks/bdnd/useSarasRegularDnDManager'
import SarasDnDProvider from '../../../../library/hooks/dndkit/SarasDnDProvider';
import { SarasDnDTypes } from '../../../../library/hooks/dndkit/SarasDnDTypes';
import useSarasDnDManager from '../../../../library/hooks/dndkit/useSarasRegularDnDManager'
import VoucherDetailRowDNDList from "./VoucherDetailRowDNDList"
import { UiView, UiViewHeading, UiTitle, UiViewContent } from "../../../../library/layout/Index";

const VoucherDetail = (props) => {
    const { formObject, viewData } = props;

    const [rowKeys, setRowKeys] = React.useState([]);

    React.useEffect(() => {
        if(viewData)
        {
            setRowKeys(Object.keys(viewData));
        }
    }, [viewData]);

    const moveServerItem = (sourceRow, previousRow) => {

        // console.log("voucher", sourceRow, previousRow);

        let customAction = {
            actionId: "refresh",
            actionName: "voucherDetail",
            actionParam: {
                reevaluate: "1",
                movedElementId: sourceRow.rowId,
                nextToElementId: previousRow ? previousRow.rowId :"0",
            },
            refreshMode:"self",
            containerKey: "custom"
        };

        formObject.onFormAction(customAction, "", null);
    }

    const onDragEnd = (result) => {
        let dropResult = sarasDnDManager.onDragEnd(viewData, rowKeys, result);
        
        if(!dropResult) return;

        setRowKeys(dropResult.rowKeys);

        //call code to reorder on server
        moveServerItem(dropResult.sourceRow, dropResult.previousRow);
    }

    const sarasDnDManager = useSarasDnDManager(SarasDnDTypes.CARD);

    if(!viewData)
        return(null)

    return (
        <UiView>
            <UiViewHeading>
                <UiTitle>
                    <FormTitle formObject={formObject} value='Invoices Adjusted' />
                </UiTitle>
            </UiViewHeading>
            <UiViewContent>
                <div className="uiEditableContent">
                    <input id="hdVDSortedIds" type="hidden" />
                </div>
                <ul className="uiListTable">
                    <li className="uiSearchHeading sort-disabled">
                        <span className="uiColumnCenter uiColumn70"><SarasTrans value="Action" /></span>
                        <span className="uiColumnCenter uiColumn100"><SarasTrans value="Trans Date" /></span>
                        <span className="uiColumnCenter uiColumn150"><SarasTrans value="Trans No" /></span>
                        <span className="uiColumnCenter uiColumn100"><SarasTrans value="Outstanding (Trans Cur)" /></span>
                        <span className="uiColumnCenter uiColumn100"><SarasTrans value="Outstanding (Voucher Cur)" /></span>
                        <span className="uiColumnCenter uiColumn70"><SarasTrans value="Voucher Cur." /></span>
                        <span className="uiColumnCenter uiColumn100"><SarasTrans value="Amount Adj" /></span>
                        <span className="uiColumnCenter uiColumn100"><SarasTrans value="Charge Adj" /></span>
                    </li>
                    <SarasDnDProvider onDragEnd={onDragEnd}>
                        <VoucherDetailRowDNDList formObject={formObject} viewData={viewData} 
                        rowKeys={rowKeys}
                        sarasDnDManager={sarasDnDManager} />
                    </SarasDnDProvider>
                </ul>
            </UiViewContent>
        </UiView>
    )
}

export default withView(VoucherDetail, "voucherDetail", "voucherDetail")
